import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { NgFor } from '@angular/common';
import { MatTextInputComponent } from '../mat-text-input/mat-text-input.component';
import { MatCheckboxInputComponent } from '../mat-checkbox-input/mat-checkbox-input.component';
import { MatIconButton, MatButton } from '@angular/material/button';

@Component({
    selector: 'app-email-list-input',
    template: `
    <div class="form-group" [formGroup]="formInGroup" style="width: 100%; max-width: 100%">
      <table class="" style="width: 100%">
        <colgroup>
          <col style="width: 220px">
          <col>
        </colgroup>

        <thead>
        <tr>
          <th><label>{{label}}</label></th>
          <th>
            <label style="text-align: center;width: 100%;">
              Receive
              <mat-icon class="explanation" matTooltip="This user will receive emails containing incoming faxes to this number.">
                info_outline
              </mat-icon>
            </label>
          </th>
          <th>
            <label style="text-align: center;width: 100%;">
              Send
              <a matTooltip="This user will have the ability to send outgoing faxes from this number through their email. Click icon to get more details."
                 href="//kb.telego.com/article/113-email-to-fax-service" target="_blank">
                <mat-icon class="explanation">info_outline</mat-icon>
              </a>
            </label>
          </th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody formArrayName="{{formFieldName}}">
        <tr *ngFor="let email of formInControl.controls; let i=index" [formGroupName]="i" style="vertical-align: top;">
          <td>
            <app-mat-text-input formControlName="email" name="email" [submitted]="submitted" [inlineLabel]="true"
                              [hideLabel]="true"></app-mat-text-input>
          </td>
          <td class="center-cell">
            <app-mat-checkbox-input formControlName="allowReceive" name="allowReceive"
                                [submitted]="submitted">
            </app-mat-checkbox-input>
          </td>
          <td class="center-cell">
            <app-mat-checkbox-input formControlName="allowSend" name="allowSend"
                                [submitted]="submitted">
            </app-mat-checkbox-input>
          </td>
          <td>
            <button mat-icon-button color="warn" (click)="removeEmail(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <button type="button" mat-stroked-button (click)="addEmail()">
        <mat-icon>add</mat-icon>{{addLabel}}
      </button>
    </div>`,
    styles: [
        '.label-text {vertical-align: middle;}',
        '.center-cell { vertical-align: middle; text-align: center}'
    ],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatIcon, MatTooltip, NgFor, MatTextInputComponent, MatCheckboxInputComponent, MatIconButton, MatButton]
})
export class EmailListInputComponent implements OnChanges, OnInit {

  @Input() formInGroup: UntypedFormGroup;
  @Input() formInControl: UntypedFormArray;
  @Input() formFieldName: string;
  @Input() label: string;
  @Input() addLabel: string;
  @Input() submitted: boolean;

  constructor(
    private fb: UntypedFormBuilder,
  ) {
  }

  ngOnInit() {
    this.removeEmail = this.removeEmail.bind(this);
    this.addEmail = this.addEmail.bind(this);
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  removeEmail(index) {
    this.formInControl.removeAt(index);
  }

  addEmail() {
    this.formInControl.push(this.fb.group({
      'email': ['', [Validators.required, Validators.email]],
      'allowReceive': [true],
      'allowSend': [true],
    }));
  }
}
